import React from "react";

const SourceCodeIcon = ({ width = "auto", height = "auto", style = {} }) =>
    <svg role="img" viewBox="0 0 989 594" style={{ ...style, width: width, height: height }}>
        <title>Source code icon</title>
        <g transform="matrix(1.00045,0,0,1.00032,-44.6872,-234.032)">
            <path d="M666.34,303.839L735.988,233.956L1033.23,530.79L736.122,827.764L666.346,757.851L893.244,530.882L666.34,303.839Z" />
        </g>
        <g transform="matrix(-1.00045,-0.000157127,0.000157146,-1.00032,1033.6,828.147)">
            <path d="M666.34,303.839L735.988,233.956L1033.23,530.79L736.122,827.764L666.346,757.851L893.244,530.882L666.34,303.839Z" />
        </g>
    </svg>;

export default SourceCodeIcon;
